import { IconButton, TextField } from '@mui/material';
import React from 'react';
import { useState } from 'react';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import VisibilityIcon from '@material-ui/icons/Visibility';

const PasswordInput = (props) => {
  const [showPass, setShowPass] = useState(false);

  return (
    <TextField
      InputProps={{
        endAdornment: (
          <IconButton onClick={() => setShowPass((p) => !p)}>
            {showPass ? <VisibilityIcon /> : <VisibilityOffIcon />}
          </IconButton>
        ),
        disableUnderline: true
      }}
      type={showPass ? 'text' : 'password'}
      {...props}
    />
  );
};

export default PasswordInput;
